/* eslint-disable react-hooks/exhaustive-deps */

import {
  I2cInput,
  I2cRadio,
  I2cRadioButton,
  I2cRadioGroup,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
} from "@webcomponents/i2cwebcomponents/dist/react";
import React from "react";
import style from "./csd.module.scss";
import * as Yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";

export const expectedHours = [
  { label: "24/7", value: "24/7" },
  { label: "Other", value: "other" },
];

const CustomerServiceLiveOperator = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
}) => {
  const liveOperatorRequire = [
    { label: "Yes", value: "yes" },
    { label: "No (will supply own live operator service)", value: "no" },
  ];

  const agentAppLang = [
    { label: "English", value: 0 },
    { label: "Spanish", value: 1 },
    { label: "Other, please specify", value: 2 },
  ];

  const handleCheckboxGroupChange = (event) => {
    const selectedValues =
      event.target?.inputValue.filter((val) => val !== null && val !== "") ||
      [];

    if (
      selectedValues.includes(2) &&
      !methods.watch("c_cs_language_option_other").length
    ) {
      methods.setError("c_cs_language_option_other", {
        message: generalErrorMessage,
      });
    } else {
      methods.clearErrors("c_cs_language_option_other");
    }

    if (selectedValues.length) methods.clearErrors("c_cs_language_option");
    else
      methods.setError("c_cs_language_option", {
        message: generalErrorMessage,
      });
    methods.setValue("c_cs_language_option", selectedValues);
    handleValueChanges();
  };

  const generalErrorMessage = "Field is required";
  const validationSchema = Yup.object({
    c_cs_operator_required: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    c_cs_toll_free_number: Yup.array().when("c_cs_operator_required", {
      is: (agentRequired) => agentRequired === "no",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    c_cs_language_option: Yup.array().when("c_cs_operator_required", {
      is: (agentRequired) => agentRequired === "yes",
      then: () =>
        Yup.array().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.array().optional(),
    }),
    c_cs_language_option_other: Yup.string().when("c_cs_language_option", {
      is: (consumerChannels) => consumerChannels.includes(2),
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    c_cs_expected_hours: Yup.array().when("c_cs_operator_required", {
      is: (agentRequired) => agentRequired === "yes",
      then: () =>
        Yup.string().required(generalErrorMessage).min(0, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    c_cs_expected_hours_other: Yup.string().when("c_cs_expected_hours", {
      is: (consumerChannels) => consumerChannels === "other",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    c_cs_backup_required: Yup.array().when("c_cs_operator_required", {
      is: (agentRequired) => agentRequired === "yes",
      then: () =>
        Yup.string().required(generalErrorMessage).min(0, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    c_cs_backup_hours: Yup.string().when("c_cs_backup_required", {
      is: (consumerChannels) => consumerChannels === "yes",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    c_cs_expected_call_volume: Yup.array().when("c_cs_operator_required", {
      is: (agentRequired) => agentRequired === "yes",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    c_cs_escalation_tree: Yup.array().when("c_cs_operator_required", {
      is: (agentRequired) => agentRequired === "yes",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
  });

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      c_cs_operator_required: "",
      c_cs_toll_free_number: "",
      c_cs_language_option: [],
      c_cs_language_option_other: "",
      c_cs_expected_hours: "",
      c_cs_expected_hours_other: "",
      c_cs_backup_required: "",
      c_cs_backup_hours: "",
      c_cs_expected_call_volume: "",
      c_cs_escalation_tree: "",
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      7: {
        ...addFormData["7"],
        "7_6": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("7_6", true);
    else setFormValidStates("7_6", false);
    handleValueChanges();
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div i2c-grid="grid gap-sm">
        <div i2c-grid="12">
          <div className="prepaidforms_innerTitle mb-16">
            Customer Services – Live Operator Required?
          </div>
          <I2cRadioGroup
            onI2cChange={(e) => {
              methods.setValue("c_cs_operator_required", e.target.value);
              methods.trigger();
              handleValueChanges();
            }}
          >
            {liveOperatorRequire.map((App, index) => (
              <I2cRadioButton
                key={index}
                name="channel_liveOperatorReq"
                value={App.value}
              >
                {App.label}
              </I2cRadioButton>
            ))}
          </I2cRadioGroup>
        </div>
        <div i2c-grid="12">
          {methods.watch("c_cs_operator_required") === "yes" && (
            <>
              <div className={style.marginTopRadio}>
                <div className="prepaidforms_innerTitle mb-16">
                  Language Options Required for CSR Support
                </div>
                <I2cCheckboxGroup
                  onI2cChange={(e) => handleCheckboxGroupChange(e)}
                >
                  <div i2c-grid="grid gap-sm">
                    {agentAppLang.map((app, index) => (
                      <I2cListItem
                        key={index}
                        i2c-grid="6@md"
                        variant="receipt"
                        label={app.label}
                        sublabel=""
                        value=""
                        type="checkbox"
                      >
                        <I2cCheckbox
                          slot="prefix"
                          value={app.value}
                          label=""
                          filled
                          className="customCheckbox"
                        ></I2cCheckbox>
                      </I2cListItem>
                    ))}
                  </div>
                </I2cCheckboxGroup>
                {methods.watch("c_cs_language_option").includes(2) && (
                  <div className={style.marginTopRadio}>
                    <div className="single-field-wrapper">
                      <Controller
                        name="c_cs_language_option_other"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            name={"c_cs_language_option_other"}
                            className="single-input-field"
                            label="Please Specify"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleValueChanges();
                            }}
                            size="large"
                          />
                        )}
                      />
                      <ErrorMessage
                        show={
                          errors.c_cs_language_option_other &&
                          methods.formState.touchedFields
                            .c_cs_language_option_other
                            ? true
                            : false
                        }
                        message={
                          errors.c_cs_language_option_other?.message ??
                          "Invalid input"
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className={style.marginTopRadio}>
                <div className="prepaidforms_innerTitle mb-16">
                  What are the expected hours of operation for customer service?
                </div>
                <I2cRadioGroup
                  onI2cChange={(e) => {
                    methods.setValue("c_cs_expected_hours", e.target.value);
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  <div i2c-grid="grid gap-sm">
                    {expectedHours.map((hours, index) => (
                      <I2cListItem
                        key={index}
                        variant="receipt"
                        label={hours.label}
                        sublabel=""
                        i2c-grid="6@md"
                        value=" "
                        type="checkbox"
                      >
                        <I2cRadio
                          slot="prefix"
                          name="channel_loExpectedHours"
                          value={hours.value}
                        ></I2cRadio>
                      </I2cListItem>
                    ))}
                  </div>
                </I2cRadioGroup>
                {methods.watch("c_cs_expected_hours") === "other" && (
                  <div className={style.marginTopRadio}>
                    <div className="single-field-wrapper">
                      <Controller
                        name="c_cs_expected_hours_other"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            name={"c_cs_expected_hours_other"}
                            className="single-input-field"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleValueChanges();
                            }}
                            label="Please Specify"
                            size="large"
                          />
                        )}
                      />
                      <ErrorMessage
                        show={
                          errors.c_cs_expected_hours_other &&
                          methods.formState.touchedFields
                            .c_cs_expected_hours_other
                            ? true
                            : false
                        }
                        message={
                          errors.c_cs_expected_hours_other?.message ??
                          "Invalid input"
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className={style.marginTopRadio}>
                <div className="prepaidforms_innerTitle mb-16">
                  Do you want i2c to provide back-up or overflow customer
                  service?
                </div>
                <I2cRadioGroup
                  onI2cChange={(e) => {
                    methods.setValue("c_cs_backup_required", e.target.value);
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {["Yes", "No"].map((hours, index) => (
                    <I2cRadioButton
                      key={index}
                      name="channel_loBackupCS"
                      value={hours.toLocaleLowerCase()}
                    >
                      {hours}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
                {methods.watch("c_cs_backup_required") === "yes" && (
                  <div className={style.marginTopRadio}>
                    <div className="single-field-wrapper">
                      <Controller
                        name="c_cs_backup_hours"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            name={"c_cs_backup_hours"}
                            className="single-input-field"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleValueChanges();
                            }}
                            label="Specify the support hours required"
                            size="large"
                          />
                        )}
                      />
                      <ErrorMessage
                        show={
                          errors.c_cs_backup_hours &&
                          methods.formState.touchedFields.c_cs_backup_hours
                            ? true
                            : false
                        }
                        message={
                          errors.c_cs_backup_hours?.message ?? "Invalid input"
                        }
                      />
                    </div>
                  </div>
                )}
              </div>

              <div i2c-grid="12" className={style.marginTopRadio}>
                <div className="prepaidforms_innerTitle mb-16">
                  Expected call volume
                </div>
                <p className={style.label}>
                  Number of calls per card per day/month for overflow time
                  periods.
                </p>
                <div className="single-field-wrapper">
                  <Controller
                    name="c_cs_expected_call_volume"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        name={"c_cs_expected_call_volume"}
                        className="single-input-field"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                      />
                    )}
                  />
                  <ErrorMessage
                    show={
                      errors.c_cs_expected_call_volume &&
                      methods.formState.touchedFields.c_cs_expected_call_volume
                        ? true
                        : false
                    }
                    message={
                      errors.c_cs_expected_call_volume?.message ??
                      "Invalid input"
                    }
                  />
                </div>
              </div>
              <div>
                <div
                  className={"prepaidforms_innerTitle " + style.marginTopRadio}
                >
                  Escalation Tree
                </div>
                <p className={style.label}>
                  Please provide escalation tree for live operator support
                </p>
                <div className="single-field-wrapper">
                  <Controller
                    name="c_cs_escalation_tree"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        name={"c_cs_escalation_tree"}
                        className="single-input-field"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        // label='Specify the support hours required'
                        size="large"
                      />
                    )}
                  />
                  <ErrorMessage
                    show={
                      errors.c_cs_escalation_tree &&
                      methods.formState.touchedFields.c_cs_escalation_tree
                        ? true
                        : false
                    }
                    message={
                      errors.c_cs_escalation_tree?.message ?? "Invalid input"
                    }
                  />
                </div>
              </div>
            </>
          )}
          {methods.watch("c_cs_operator_required") === "no" && (
            <>
              <p className={style.label}>
                If you opt to provide your own live operator service, please
                provide toll free number
              </p>
              <div className="single-field-wrapper">
                <Controller
                  name="c_cs_toll_free_number"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      name={"c_cs_toll_free_number"}
                      className="single-input-field"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.c_cs_toll_free_number &&
                    methods.formState.touchedFields.c_cs_toll_free_number
                      ? true
                      : false
                  }
                  message={
                    errors.c_cs_toll_free_number?.message ?? "Invalid input"
                  }
                />
              </div>
            </>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CustomerServiceLiveOperator;
